import { Box, Typography } from "@mui/material";
import { PeopleOutline as PeopleOutlineIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

function EmptyState() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        textAlign: "center",
        padding: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
      data-testid="driver-list-empty-state"
    >
      <PeopleOutlineIcon
        sx={{
          fontSize: 80,
          color: "text.secondary",
          opacity: 0.5,
        }}
      />
      <Typography variant="h6" color="text.primary" sx={{ fontWeight: 600 }}>
        {t("driverShiftTracker.emptyState.noDrivers.title")}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 400 }}>
        {t("driverShiftTracker.emptyState.noDrivers.message")}
      </Typography>
    </Box>
  );
};

export default EmptyState;
